import { useEffect, useRef, useCallback } from "react";
// import { useState } from "react";
// import { Modal, Button, Typography } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/slices/userslice";
import api from "../../config/axiosInstance";

// const { Text } = Typography;

const IDLE_TIMEOUT =
  (Number(process.env.REACT_APP_SESSION_IDLE_TIMEOUT_MINUTES) || 120) * 60 * 1000;
// Warning-modal machinery (disabled — silent auto-logout). Kept for easy re-enable.
// const WARNING_BEFORE =
//   (Number(process.env.REACT_APP_SESSION_WARNING_BEFORE_MINUTES) || 5) * 60 * 1000;
// const WARNING_DURATION = WARNING_BEFORE;

function SessionTimeout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [showWarning, setShowWarning] = useState(false);
  // const [countdown, setCountdown] = useState(WARNING_DURATION / 1000);
  const idleTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  // const logoutTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  // const countdownRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const performLogout = useCallback(async () => {
    clearAllTimers();
    // setShowWarning(false);
    try {
      await api.post("auth/logout");
    } catch (e) {}
    dispatch(logout({}));
    navigate("/");
  }, [dispatch, navigate]);

  const clearAllTimers = () => {
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    // if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    // if (countdownRef.current) clearInterval(countdownRef.current);
  };

  // After IDLE_TIMEOUT of no activity, log the user out silently (no warning modal).
  const resetIdleTimer = useCallback(() => {
    clearAllTimers();
    idleTimerRef.current = setTimeout(() => {
      performLogout();
    }, IDLE_TIMEOUT);
  }, [performLogout]);

  // const handleStayLoggedIn = () => {
  //   clearAllTimers();
  //   setShowWarning(false);
  //   setCountdown(WARNING_DURATION / 1000);
  //   resetIdleTimer();
  // };

  useEffect(() => {
    const events = ["mousedown", "keypress", "scroll", "touchstart"];

    const handleActivity = () => {
      resetIdleTimer();
    };

    events.forEach((event) => window.addEventListener(event, handleActivity));
    resetIdleTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
      clearAllTimers();
    };
  }, [resetIdleTimer]);

  // const formatTime = (seconds: number) => {
  //   const m = Math.floor(seconds / 60);
  //   const s = seconds % 60;
  //   return `${m}:${s.toString().padStart(2, "0")}`;
  // };

  // Warning modal disabled — silent auto-logout after IDLE_TIMEOUT.
  // return (
  //   <Modal
  //     open={showWarning}
  //     closable={false}
  //     centered
  //     footer={null}
  //     width={420}
  //     maskClosable={false}
  //   >
  //     <div style={{ textAlign: "center", padding: "20px 0" }}>
  //       <div
  //         style={{
  //           width: 80,
  //           height: 80,
  //           borderRadius: "50%",
  //           background: "#fff7e6",
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //           margin: "0 auto 20px",
  //           fontSize: 40,
  //         }}
  //       >
  //         ⏱
  //       </div>
  //       <div
  //         style={{
  //           fontFamily: "Montserrat-SemiBold",
  //           fontSize: 18,
  //           marginBottom: 8,
  //         }}
  //       >
  //         Session Expiring Soon
  //       </div>
  //       <Text
  //         type="secondary"
  //         style={{ display: "block", marginBottom: 20, fontSize: 14 }}
  //       >
  //         Your session will expire due to inactivity.
  //       </Text>
  //       <div
  //         style={{
  //           fontSize: 36,
  //           fontFamily: "Montserrat-SemiBold",
  //           color: countdown <= 60 ? "#ff4d4f" : "#faad14",
  //           marginBottom: 24,
  //         }}
  //       >
  //         {formatTime(countdown)}
  //       </div>
  //       <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
  //         <Button size="large" danger onClick={performLogout}>
  //           Logout Now
  //         </Button>
  //         <Button size="large" type="primary" onClick={handleStayLoggedIn}>
  //           Stay Logged In
  //         </Button>
  //       </div>
  //     </div>
  //   </Modal>
  // );

  return null;
}

export default SessionTimeout;
